module.exports = __webpack_public_path__ + "img/wkdthg-dark.1ed1ebb5.png";